module.exports = __webpack_public_path__ + "img/bingo_ball-37.7e75b72e.png";